import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function CarouselManager() {
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [deleteId, setDeleteId] = useState(null);


  useEffect(() => {
    axios
      .get("https://api.livestockify.com/api/admin/carousel")
      .then((res) => setImages(res.data));
  }, []);

  // const handleDelete = (id) => {
  //   axios.delete(`https://api.livestockify.com/api/admin/carousel/${id}`);

  //   setImages((prev) => prev.filter((img) => img.id !== id));
  // };

const handleDelete = async () => {
  try {
    await axios.delete(
      `https://api.livestockify.com/api/admin/carousel/${deleteId}`
    );

    setImages((prev) => prev.filter((img) => img.id !== deleteId));
    setDeleteId(null);
  } catch (err) {
    console.error("Delete failed", err);
  }
};


  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-6 md:p-8">
        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-lg font-semibold ml-10 text-green-700">
            Carousel Images
          </h1>

          <button
            onClick={() => navigate("/uploads/carousel/add")}
            className="border border-gray-300 px-4 py-1.5 rounded-md text-sm hover:bg-gray-50"
          >
            + Add Image
          </button>
        </div>

        {/* IMAGES GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {images.map((img) => (
            <div
              key={img.id}
              className="border rounded-lg overflow-hidden shadow-sm"
            >
              <img
                src={img.imageUrl}
                alt="carousel"
                className="w-full h-44 object-cover"
              />

              <div className="px-3 py-2 text-sm">
                <p className="text-green-600 font-medium">Image ID: {img.id}</p>

                <div className="flex justify-end gap-4 mt-1">
                  <button
                    onClick={() =>
                      navigate(`/uploads/carousel/edit/${img.id}`, {
                        state: {
                          imageUrl: img.imageUrl,
                        },
                      })
                    }
                    className="text-green-600 text-sm hover:underline"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => setDeleteId(img.id)}
                    className="text-red-500 text-sm hover:underline"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* EMPTY STATE */}
        {images.length === 0 && (
          <p className="text-gray-500 text-sm mt-10">
            No carousel images available.
          </p>
        )}
      </div>

{deleteId && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl p-6 w-[90%] max-w-sm">
      <h3 className="text-lg font-semibold mb-3">
        Confirm Deletion
      </h3>

      <p className="text-sm text-gray-600 mb-6">
        Are you sure you want to proceed with this deletion?
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setDeleteId(null)}
          className="border px-4 py-2 rounded-md text-sm"
        >
          Cancel
        </button>

        <button
          onClick={handleDelete}
          className="bg-red-600 text-white px-4 py-2 rounded-md text-sm"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}
